import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { setupAxiosInterceptors } from "./global/authUtils";

// Setup axios interceptors for global auth handling
setupAxiosInterceptors();

// Create root and render the App component
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((registration) => {})
      .catch((registrationError) => {});
  });
}

// Register the service worker for PWA functionality
serviceWorkerRegistration.register();
